import { AdornisRouter } from '@adornis/base/client/a-router';
import type { Maybe } from '@adornis/base/utilTypes';
import OptimisticObservable from '@adornis/baseql/optimisticObservable';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element';
import { ObservableController } from '@adornis/chemistry/controllers/observable-controller';
import { SizeController } from '@adornis/chemistry/controllers/size-controller';
import { css } from '@adornis/chemistry/directives/css';
import '@adornis/germanium/components/ge-button';
import '@adornis/germanium/components/ge-card';
import GermaniumDialog from '@adornis/germanium/components/ge-dialog';
import '@adornis/germanium/components/ge-input';
import '@adornis/user-forms/x-login';
import { WTGUser } from 'db/wtg-user';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { ref } from 'lit/directives/ref.js';
import { filter, take, tap } from 'rxjs/operators';
import { injectColorfulStuffForForms } from './inject-colorful-stuff-for-forms';
import './wtg-login-form';
import { WTGLoginForm } from './wtg-login-form';

@customElement('wtg-login')
export class WTGLogin extends ChemistryLitElement {
  styles = () => ({ ':host': { width: '100%', height: '100vh' } });
  @state() errorMsg = '';
  @state() visiblePassword = false;

  @state() size = new SizeController(this);

  public render() {
    return html`
      <x-flex crossaxis-center ${css({ width: '100%', paddingTop: '200px', position: 'relative' })}>
        ${injectColorfulStuffForForms(this.size.width)} ${this.formBox()}
      </x-flex>
    `;
  }

  private _loginForm?: WTGLoginForm;

  @state() user = new ObservableController(
    this,
    (WTGUser.currentUser as OptimisticObservable<Maybe<WTGUser>>).whenReady.pipe(
      filter(Boolean),
      take(1),
      tap(user => {
        if (user.hasOnboarded) AdornisRouter.goTo('/');
        else AdornisRouter.goTo('/create_profile/name');
      }),
    ),
  );

  private formBox() {
    return html`
      <x-flex space="xl" ${css({ width: '100%', maxWidth: '700px' })}>
        <ge-h1 ${css({ textAlign: 'center', fontWeight: '700' })}> Welcome back! </ge-h1>

        <x-flex ${css({ padding: `0px 70px` })}>
          <wtg-login-form
            ${ref(loginForm => (this._loginForm = loginForm))}
            .userEntity=${WTGUser}
            @login=${async (e: CustomEvent<WTGUser>) => {
              this.errorMsg = '';
            }}
            @error=${e => {
              GermaniumDialog.alert(JSON.stringify(e.detail));
            }}
          >
          </wtg-login-form>
        </x-flex>
        ${this.sso()}

        <x-flex padding="md">
          <ge-text ${css({ textAlign: 'center', color: '#617182' })}>
            By continuing, you agree to our
            <a href="/terms" ${css({ color: '#617182' })}> Terms and Conditions </a> and our
            <a href="/privacy" ${css({ color: '#617182' })}> Privacy Policy </a>
          </ge-text>
        </x-flex>
      </x-flex>
    `;
  }

  private sso() {
    return ''; // dont use atm
  }
}
